import { UUID } from "../../utils/typeDefinitions"
import Document from "./Document"
import ProjectDocument from "./ProjectDocument"

class StoreyDocument extends ProjectDocument {
    storeyId: UUID
    
    constructor(projectId: UUID, storeyId: UUID, document: Document, version: number = 1) {
        super(projectId, document, version);
        this.storeyId = storeyId
    }
    
    toJson(): any {
    
        return {
            ...super.toJson(),
            storeyId: this.storeyId
        };
    }
    
    static fromJson(json: any): StoreyDocument {
        return new StoreyDocument(
            json.projectId,
            json.storeyId,
            Document.fromJson(json.document),
            json.version || 1
        );
    }

    getEntityId(): UUID {
        return this.storeyId;
    }
}

export default StoreyDocument;